import React from 'react';
import ReactDOM from 'react-dom/client';
// import "./index.css";
import './css/base.css';
import SiteEntry from './public-site/SiteEntry';
import './css/landing.css';
// import reportWebVitals from "./reportWebVitals";

// Suppress ResizeObserver loop errors - this is a known browser quirk
// that doesn't affect functionality but can clutter the console in development
const originalErrorHandler = window.onerror;

// Suppress ResizeObserver errors at the window level (for React error boundaries)
window.onerror = (message, source, lineno, colno, error) => {
  if (
    typeof message === 'string' &&
    message.includes('ResizeObserver loop completed with undelivered notifications')
  ) {
    return true; // Suppress the error
  }
  // Call original error handler if it exists
  if (originalErrorHandler) {
    return originalErrorHandler(message, source, lineno, colno, error);
  }
  return false;
};

// Suppress unhandled promise rejections for ResizeObserver errors
const originalUnhandledRejection = window.onunhandledrejection;
window.onunhandledrejection = (event) => {
  const reason = event.reason;
  const msg =
    typeof reason === 'string'
      ? reason
      : reason && typeof reason.message === 'string'
        ? reason.message
        : '';
  if (msg && /ResizeObserver loop/i.test(msg)) {
    event.preventDefault();
    return;
  }
  if (originalUnhandledRejection) {
    originalUnhandledRejection(event);
  }
};

if (typeof window.reportError === 'function') {
  const origReportError = window.reportError.bind(window);
  window.reportError = (err) => {
    if (err && typeof err.message === 'string' && /ResizeObserver loop/i.test(err.message)) {
      return;
    }
    origReportError(err);
  };
}

const isResizeObserverLoopError = (message) =>
  typeof message === 'string' && /ResizeObserver loop/i.test(message);

// Backup (bundle runs after HTML inline script): catch all variants and error.message
window.addEventListener(
  'error',
  (event) => {
    const msg =
      event?.message ||
      event?.error?.message ||
      (typeof event?.error === 'string' ? event.error : '');
    if (isResizeObserverLoopError(msg)) {
      event.stopImmediatePropagation();
      event.preventDefault();
    }
  },
  true,
);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<SiteEntry />);

// If you want to start measuring performance in your app, pass a function

// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
